import React, {FC, useState} from "react";
import {Switch} from "./switch";
import {Label} from "./label";

export type ToggleSwitchProps = {
    activeLabel: string;
    inactiveLabel: string;
    value: boolean;
    onChange: (value: boolean) => void;
    disabled: boolean;
}

export const ToggleSwitch: FC<ToggleSwitchProps> = ({activeLabel, inactiveLabel, value, onChange, disabled}) => {
    const selectedStyle = "font-bold text-orange-300";
    const unselectedStyle = "text-orange-100/60";
    const [switchState, setSwitchState] = useState<boolean>(value);

    const handleSwitch = (value: boolean) => {
        if (!disabled) {
            setSwitchState(value);
            onChange(value);
        }
    };

    return (
        <div className="flex items-center space-x-3">
            <Label
                className={`${switchState ? unselectedStyle : selectedStyle} cursor-pointer transition`}
                onClick={() => handleSwitch(false)}
            >
                {inactiveLabel}
            </Label>

            <Switch
                checked={switchState}
                onCheckedChange={handleSwitch}
                disabled={disabled}
                className="data-[state=checked]:bg-orange-300 bg-orange-100 border border-orange-200 transition"
            />

            <Label
                className={`${switchState ? selectedStyle : unselectedStyle} cursor-pointer transition`}
                onClick={() => handleSwitch(true)}
            >
                {activeLabel}
            </Label>
        </div>
    );
};

ToggleSwitch.displayName = "ToggleSwitch";
ToggleSwitch.whyDidYouRender = false;